/**
 * Session storage utility functions
 */

import { authConfig } from '../config/auth';

const TOKEN_KEY = authConfig.sessionStorageKey;

export const sessionStorageUtils = {
  /**
   * Set token in session storage
   */
  setToken: (token: string): void => {
    sessionStorage.setItem(TOKEN_KEY, token);
  },

  /**
   * Get token from session storage
   */
  getToken: (): string | null => {
    return sessionStorage.getItem(TOKEN_KEY);
  },

  /**
   * Remove token from session storage
   */
  removeToken: (): void => {
    sessionStorage.removeItem(TOKEN_KEY);
  },

  /**
   * Check if token exists in session storage
   */
  hasToken: (): boolean => {
    return sessionStorage.getItem(TOKEN_KEY) !== null;
  },

  /**
   * Clear all session storage
   */
  clear: (): void => {
    sessionStorage.clear();
  }
};
